const storeToken = (token) => {
  try {
    localStorage.setItem("token", token);
    // Fresh login: reset inactivity timestamp so a stale one doesn't force an immediate logout
    localStorage.setItem("user-activity-timestamp", Date.now().toString());
  } catch (error) {
    console.log("Error storing in token", error);
  }
};

const getToken = () => {
  try {
    return localStorage.getItem("token");
  } catch (error) {
    console.log("Error getting in token", error``);
  }
};

const storeAccessToken = (accessToken) => {
  try {
    localStorage.setItem("accessToken", accessToken);
  } catch (error) {
    console.log("Error storing in access token", error);
  }
};

const getAccessToken = () => {
  try {
    return localStorage.getItem("accessToken");
  } catch (error) {
    console.log("Error getting in access token", error``);
  }
};

const storeLeadID = (leadID) => {
  try {
    localStorage.setItem("leadID", leadID);
  } catch (error) {
    console.log("Error storing in leadID", error);
  }
};

const getLeadID = () => {
  try {
    return Number(localStorage.getItem("leadID"));
  } catch (error) {
    console.log("Error getting in leadID", error);
  }
};

const storeCustomerID = (customerID) => {
  try {
    localStorage.setItem("customerID", customerID);
  } catch (error) {
    console.log("Error storing in customer id", error);
  }
};

const getCustomerID = () => {
  try {
    const id = localStorage.getItem("customerID");
    return id ? Number(id) : null;
  } catch (error) {
    console.log("Error getting customer id", error);
    return null;
  }
};

const storePhoneNo = (phoneNo) => {
  try {
    localStorage.setItem("phoneNo", phoneNo);
  } catch (error) {
    console.log("Error storing in phone number", error);
  }
};

const getPhoneNo = () => {
  try {
    return Number(localStorage.getItem("phoneNo"));
  } catch (error) {
    console.log("Error getting in phone number", error);
  }
};

const storeProductId = (productId) => {
  try {
    localStorage.setItem("productId", productId);
  } catch (error) {
    console.log("Error storing in product id", error);
  }
};

const getProductId = () => {
  try {
    return Number(localStorage.getItem("productId"));
  } catch (error) {
    console.log("Error getting in product id", error);
  }
};

const storeEMITenure = (emiTenure) => {
  try {
    localStorage.setItem("emiTenure", emiTenure);
  } catch (error) {
    console.log("Error storing in emi tenure", error);
  }
};

const getEMITenure = () => {
  try {
    return Number(localStorage.getItem("emiTenure"));
  } catch (error) {
    console.log("Error getting in emi tenure", error);
  }
};

const storeAttributeKey = (key) => {
  try {
    localStorage.setItem("attributeKey", key);
  } catch (error) {
    console.log("Error storing in attribute key", error);
  }
};

const getAttributeKey = () => {
  try {
    return Number(localStorage.getItem("attributeKey"));
  } catch (error) {
    console.log("Error getting in attribute key", error);
  }
};

const storeProductType = (productType) => {
  try {
    localStorage.setItem("productType", productType);
  } catch (error) {
    console.log("Error storing in product type", error);
  }
};

const getProductType = () => {
  try {
    return Number(localStorage.getItem("productType"));
  } catch (error) {
    console.log("Error getting in product type", error);
  }
};
const storeIsLentraCustomer = (isLentraCustomer) => {
  try {
    localStorage.setItem("isLentraCustomer", isLentraCustomer);
  } catch (error) {
    console.log("Error storing in lentra customer", error);
  }
};

const getIsLentraCustomer = () => {
  try {
    return localStorage.getItem("isLentraCustomer");
  } catch (error) {
    console.log("Error getting in lentra customer ", error);
  }
};

export {
  storeToken,
  getToken,
  storeAccessToken,
  getAccessToken,
  storeLeadID,
  getLeadID,
  storeCustomerID,
  getCustomerID,
  storePhoneNo,
  getPhoneNo,
  storeProductId,
  getProductId,
  storeEMITenure,
  getEMITenure,
  storeAttributeKey,
  getAttributeKey,
  storeProductType,
  getIsLentraCustomer,
  storeIsLentraCustomer,
  getProductType,
};
